// keep it sync with ryde-backend/libs/shared/src/constants/internalization.ts
export const CURRENCY = {
  EUR: "€",
  ILS: "₪",
  USD: "$",
} as const;

export type CurrencyKey = keyof typeof CURRENCY;
export type CurrencySign = (typeof CURRENCY)[CurrencyKey];
